import getShowSlideshowGalleryImages from "selectors/breakpoint/getShowSlideshowGalleryImages";
import { createSelector } from "reselect";

const getIsScrubbing = (state, ownProps) => !!ownProps.isScrubbing;
const getSlideshowGalleryToggle = (state) =>
  state.modals.slideshowGalleryToggle;

export const makeGetShowSlideshowGallery = () =>
  createSelector(
    [getIsScrubbing, getShowSlideshowGalleryImages, getSlideshowGalleryToggle],
    (isScrubbing, showSlideshowGalleryImages, slideshowGalleryToggle) =>
      // Only return true if we allow gallery images and the toggle is on. If the toggle is on
      // and we don't allow them, then the slideshow info will show instead
      showSlideshowGalleryImages && (slideshowGalleryToggle || isScrubbing),
  );

export default makeGetShowSlideshowGallery();
